<template>
  <ListLayout
    :title="`${userModule.userPlural}`"
    :tableData="userList"
    :tableHeader="tableHeaders"
    :total="totalItem"
    @getList="getUserList"
    :context="context"
    ref="listTable"
  >
    <template #listAction>
      <v-menu offset-y v-if="permissions && permissions.add">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <div v-on="{ ...tooltip }">
                <PrimaryButton
                  id="userManagementAdd"
                  :disabled="isButtonDisabled"
                  v-bind="attrs"
                  v-on="{ ...menu }"
                  :name="`Add ${userModule.user}`"
                  icon="mdi-plus"
                  iconSize="x-large"
                >
                </PrimaryButton>
              </div>
            </template>
            <span>{{ buttonTooltip }}</span>
          </v-tooltip>
        </template>
        <v-list dense flat>
          <v-list-item @click="$router.push({ name: 'add-normal-user' })">
            <v-list-item-title>Add {{ userModule.user }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showBulkUploadDialog = true">
            <v-list-item-title>Import {{ userModule.user }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- <v-btn
        @click="$router.push({ path: '/app/client/user/normal/add' })"
        color="primary"
        class="white--text"
        depressed
      >
        <v-icon>mdi-plus</v-icon>
        <span class="text-body-2">Add User</span>
      </v-btn> -->
    </template>
    <template #rightFilterSlot>
      <div class="d-flex align-center justify-end w-100">
        <RefreshListButton
          id="userManagementRefreshList"
          :isIcon="false"
          @click="$refs.listTable.searchTriggered()"
        />
        <UserFilter
          :filter="normalUserFilters"
          :isChips="Object.keys(normalUserFilters).length > 0"
          @apply="getUserList({ limit: 10, offset: 0 })"
          @reset="resetFilter"
        />
      </div>
    </template>
    <template #dialogs>
      <BulkUpload
        uploadTo="user_management"
        v-model="showBulkUploadDialog"
        @refreshList="
          checkSubscriptionLimit();
          getUserList({ limit: 10, offset: 0 });
        "
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import UserFilter from "@/components/ModuleBasedComponents/NormalUser/UserFilter.vue";
import UserButton from "@/components/Button/UserButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import BulkUpload from "@/components/BaseComponents/BulkUpload.vue";
import { mapState } from "vuex";
import { filterModules } from "@/utils/fieldConstants";
import { userModule } from "@/utils/moduleMapping";

export default {
  components: {
    UserFilter,
    UserButton,
    ListLayout,
    RefreshListButton,
    BulkUpload,
  },
  data() {
    return {
      userModule,
      permissions: null,
      sorting: {},
      usersPerPage: 10,
      pageNo: 1,
      totalItem: 0,
      userList: [],
      headerSelected: [
        {
          headerName: "Username",
          field: "username",
          sortable: true,
        },
        {
          headerName: "First Name",
          field: "first_name",
          sortable: true,
        },
        {
          headerName: "Last Name",
          field: "last_name",
          sortable: false,
        },
        {
          headerName: "Email",
          field: "email",
          sortable: false,
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
      ],

      isEditing: false,
      showUserForm: false,
      selectedUserID: null,

      showBulkUploadDialog: false,

      isButtonDisabled: false,
      buttonTooltip: "Add Users",
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 100,
          sortable: false,
          width: 100,
          cellRenderer: "UserButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    ...mapState("userProfile", {
      normalUserFilters: (state) => state.normal_user_filters,
    }),
  },
  methods: {
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "normaluser",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    resetFilter() {
      this.$store.commit("userProfile/resetFilters", {
        moduleKey: "normal_user_filters",
      });
      this.getUserList({ limit: 10, offset: 0 });
    },
    async getUserList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.normalUserFilters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      await this.$store.dispatch("userProfile/updateUserFilters", {
        filter_data: { ...this.normalUserFilters },
        filter_type: filterModules.NORMAL_USER,
      });

      this.$api.normalUser
        .getNormalUserList(params)
        .then((res) => {
          this.userList = res.data;
          this.totalItem = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("user");

    this.checkSubscriptionLimit();
  },
};
</script>
